export function EditableText({ editing, value, onChange, placeholder, className = "", as: Tag = "p", multiline = false, testId, inputClass = "" }) {
  if (!editing) {
    if (!value) return null;
    return <Tag className={className} data-testid={testId}>{value}</Tag>;
  }
  const base = `w-full rounded-xl border-2 border-dashed border-sbg-fuchsia/70 bg-white/90 px-3 py-2 text-sbg-burgundy outline-none focus:border-sbg-fuchsia ${inputClass}`;
  return multiline ? (
    <textarea data-testid={`${testId}-input`} value={value || ""} onChange={(e) => onChange(e.target.value)} placeholder={placeholder} rows={4} className={`${base} ${className}`} />
  ) : (
    <input data-testid={`${testId}-input`} value={value || ""} onChange={(e) => onChange(e.target.value)} placeholder={placeholder} className={`${base} ${className}`} />
  );
}
